<template>
  <div>
    <div v-if="isLoading">
      <Spin></Spin>
    </div>
    <div v-else>
      <div v-bind="getRootProps()">
        <input v-bind="getInputProps()" />
        <p v-if="isDragActive">Перенесите файлы сюда или кликните по этой области  и выберите файл для загрузки ...</p>
        <p v-else>Перенесите файлы сюда или кликните по этой области  и выберите файл для загрузки ...</p>
      </div>
      <ul>
        <li v-for="(link,index) in links" :key="index"><a :href="link[0]">{{ link[0] }}</a> <delete-filled style="margin-left: 15px;" @click="deleteFile(link[1],link[2])" /></li>
      </ul>
    </div>
  </div>
</template>

<script>
// assets/project/src/components/Base/DropzoneComponent.vue

import { ref } from "vue";
import { useDropzone } from "vue3-dropzone";
import { Spin } from 'ant-design-vue';
import { DeleteFilled } from '@ant-design/icons-vue';
import axios from 'axios';

export default {
  props: {
    url: String,
    getFilesUrl: String,
    currentId: {},
    show: {},
    type: String
  },
  name: "UseDropzoneDemo",
  components: {
    DeleteFilled,
    Spin
  },
  mounted() {
    this.getFiles();
  },
  setup(props, { emit }) {

    let links = ref([]);
    let isLoading = ref(false);

    function getFiles() {
      isLoading.value = true;
      axios
          .post(this.getFilesUrl+''+props.currentId, null, {
            params: {
              show: props.show
            }
          })
          .then((response) => {
            links.value = response.data;
            isLoading.value = false;
          })
          .catch((err) => {
            console.error(err);
          });
    }


    function deleteFile(path,name) {
      isLoading.value = true;
      const self = this;
      axios
          .post('/delete_area_photo/'+props.currentId, null, {
            params: {
              path: path,
              name: name,
              show: props.show,
              type: props.type
            }
          })
          .then((response) => {
            emit('onChange');
            links.value = response.data;
            isLoading.value = false;
          })
          .catch((err) => {
            console.error(err);
          });
    }


    const saveFiles = (files) => {
      const self = this;
      const formData = new FormData(); // pass data as a form
      for (var x = 0; x < files.length; x++) {
        // append files as array to the form, feel free to change the array name
        formData.append("images[]", files[x]);
      }

      // post the formData to your backend where storage is processed. In the backend, you will need to loop through the array and save each file through the loop.
      isLoading.value = true;
      axios
          .post(props.url+'/'+props.currentId, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              show: props.show
            }
          })
          .then((response) => {
						emit('onChange');
            isLoading.value = false;
            links.value = response.data;
          })
          .catch((err) => {
            console.error(err);
          });
    };

    function onDrop(acceptFiles, rejectReasons) {
      saveFiles(acceptFiles); // saveFiles as callback

      console.log(rejectReasons);
    }

    const { getRootProps, getInputProps, ...rest } = useDropzone({ onDrop });

    return {
      getRootProps,
      getInputProps,
      deleteFile,
      getFiles,
      isLoading,
      links,
      ...rest,
    };
  },
  // watch: {
  //   show() {
  //     console.log('1');
  //     this.getFiles();
  //   }
  // }
};
</script>